import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { UserService } from './user.service';
import { CompanyService } from './company.service';
import { Company } from '../models/company.model';

/**
 * The InitService injects Services into Models
 *
 * HINT: Add the InitService into app.component.ts
 */
@Injectable({
	providedIn: 'root'
})
export class InitService {
	/**
	 * Constructor
	 *
	 * Injects the services into the models
	 *
	 * @param userService
	 * @param companyService
	 */
	constructor(protected userService: UserService, protected companyService: CompanyService) {
		User.init(userService);
		Company.init(companyService);
	}
}
